import { Grid } from "semantic-ui-react";
import { TitleView } from "../titleView/TitleView";
import { CustomButton } from "../button/Button";
import InputWithDropDown from "../inputWithDropDown/InputWithDropDown";
import {
  ENERGY_UNIT_TYPES_OPTIONs,
  POWER_UNIT_TYPES_OPTIONs,
  VOLUME_UNIT_TYPES_OPTIONs,
  WEIGHT_UNIT_TYPES_OPTIONs
} from "../../config/optionsConstants";

const SimulationMeasurementDetails = ({
  control,
  errors,
  customCapacityValidation,
  customInputValidation,
  customOutputValidation,
  addIngredientActive,
  setViewIngredient,
  data,
  originalProcessData,
  setUnitTypes,
  unitTypes
}: any) => {
  return (
    <>
      <TitleView title="Measurement Details" />
      <Grid>
        <Grid.Row divided>
          <Grid.Column computer={8} tablet={8} mobile={8}>
            <Grid>
              <Grid.Column computer={5} tablet={8} mobile={16}>
                <label className="textLabel">Capacity (kg input/hr)</label>
                <br />
                <label className="textLabel">{originalProcessData?.capacity}</label>
              </Grid.Column>
              <Grid.Column computer={5} tablet={8} mobile={16}>
                <label className="textLabel">Input(kg)</label>
                <br />
                <label className="textLabel">{originalProcessData?.input}</label>
              </Grid.Column>
              <Grid.Column computer={5} tablet={8} mobile={16}>
                <label className="textLabel">Output(kg)</label>
                <br />
                <label className="textLabel">{originalProcessData?.output}</label>
              </Grid.Column>
              <Grid.Column computer={5} tablet={8} mobile={16}>
                <label className="textLabel">Bio waste/side stream (kg)</label>
                <br />
                <label className="textLabel">{originalProcessData?.sideStream}</label>
              </Grid.Column>
              <Grid.Column computer={5} tablet={8} mobile={16}>
                <label className="textLabel">Heat (MJ/kg input)</label>
                <br />
                <label className="textLabel">{originalProcessData?.heat}</label>
              </Grid.Column>
              <Grid.Column computer={5} tablet={8} mobile={16}>
                <label className="textLabel">Electricity (kWh/kg input)</label>
                <br />
                <label className="textLabel">{originalProcessData?.electricity}</label>
              </Grid.Column>
              <Grid.Column style={{ marginTop: 10 }} computer={5} tablet={8} mobile={16}>
                <label className="textLabel">Water (m3 per kg input)</label>
                <br />
                <label className="textLabel">{originalProcessData?.water}</label>
              </Grid.Column>
            </Grid>
          </Grid.Column>
          <Grid.Column computer={8} tablet={8} mobile={8}>
            <Grid>
              <Grid.Column computer={4} tablet={8} mobile={16}>
                <InputWithDropDown
                  defaultSelectValue={unitTypes.capacityUnit}
                  options={WEIGHT_UNIT_TYPES_OPTIONs}
                  selectOption={(value: string | number) =>
                    setUnitTypes({ ...unitTypes, capacityUnit: value })
                  }
                  control={control}
                  labelName={"Capacity (input/hr)*"}
                  placeholder="Capacity Unit"
                  name={`capacity`}
                  errors={errors?.capacity}
                  errorMessage="Capacity Unit is required"
                  defaultValue={0}
                  ref={customCapacityValidation}
                  valueAsNumber={true}
                  transform={{
                    input: (value: any) => (isNaN(value) || value === 0 ? "" : value.toString()),
                    output: (e: any) => {
                      return e;
                    }
                  }}
                  required={true}
                  customRequired={true}
                />
              </Grid.Column>
              <Grid.Column computer={4} tablet={8} mobile={16}>
                <InputWithDropDown
                  defaultSelectValue={unitTypes.inputUnit}
                  options={WEIGHT_UNIT_TYPES_OPTIONs}
                  selectOption={(value: string | number) =>
                    setUnitTypes({ ...unitTypes, inputUnit: value })
                  }
                  control={control}
                  labelName={"Input*"}
                  placeholder="Input"
                  name={`input`}
                  errors={errors?.input}
                  ref={customInputValidation}
                  errorMessage="Input is required"
                  customRequired={true}
                  valueAsNumber={true}
                  transform={{
                    input: (value: any) => (isNaN(value) || value === 0 ? "" : value.toString()),
                    output: (e: any) => {
                      return e;
                    }
                  }}
                  required={true}
                />
              </Grid.Column>
              <Grid.Column computer={4} tablet={8} mobile={16}>
                <InputWithDropDown
                  defaultSelectValue={unitTypes.outputUnit}
                  options={WEIGHT_UNIT_TYPES_OPTIONs}
                  selectOption={(value: string | number) =>
                    setUnitTypes({ ...unitTypes, outputUnit: value })
                  }
                  control={control}
                  labelName={"Output*"}
                  placeholder="Output"
                  name={`output`}
                  errors={errors?.output}
                  errorMessage="Output is required"
                  customRequired={true}
                  valueAsNumber={true}
                  ref={customOutputValidation}
                  transform={{
                    input: (value: any) => (isNaN(value) || value === 0 ? "" : value.toString()),
                    output: (e: any) => {
                      return e;
                    }
                  }}
                  required={true}
                />
              </Grid.Column>
              <Grid.Column computer={4} tablet={8} mobile={16}>
                <InputWithDropDown
                  defaultSelectValue={unitTypes.sideStreamUnit}
                  options={WEIGHT_UNIT_TYPES_OPTIONs}
                  selectOption={(value: string | number) =>
                    setUnitTypes({ ...unitTypes, sideStreamUnit: value })
                  }
                  control={control}
                  labelName={"Bio waste/side stream"}
                  placeholder="Bio waste/side stream"
                  name={`sideStream`}
                  errors={errors?.sideStream}
                  errorMessage="Bio waste/side stream is required"
                  transform={{
                    input: (value: any) => (isNaN(value) || value === 0 ? "" : value.toString()),
                    output: (e: any) => {
                      return e;
                    }
                  }}
                />
              </Grid.Column>

              <Grid.Column computer={4} tablet={8} mobile={16} className="paddingRemoveTop">
                <InputWithDropDown
                  defaultSelectValue={unitTypes.heatUnit}
                  options={ENERGY_UNIT_TYPES_OPTIONs}
                  selectOption={(value: string | number) =>
                    setUnitTypes({ ...unitTypes, heatUnit: value })
                  }
                  control={control}
                  labelName={"Heat (input)"}
                  placeholder="0"
                  name={`heat`}
                  errors={errors?.heat}
                />
              </Grid.Column>

              <Grid.Column computer={4} tablet={8} mobile={16} className="paddingRemoveTop">
                <InputWithDropDown
                  defaultSelectValue={unitTypes.electricityUnit}
                  options={POWER_UNIT_TYPES_OPTIONs}
                  selectOption={(value: string | number) =>
                    setUnitTypes({ ...unitTypes, electricityUnit: value })
                  }
                  transform={{
                    input: (value: any) => (isNaN(value) || value === 0 ? "" : value.toString()),
                    output: (e: any) => {
                      return e;
                    }
                  }}
                  control={control}
                  labelName={"Electricity (input)"}
                  placeholder="0"
                  name={`electricity`}
                />
              </Grid.Column>
              <Grid.Column computer={4} tablet={8} mobile={16} className="paddingRemoveTop">
                <InputWithDropDown
                  defaultSelectValue={unitTypes.waterUnit}
                  options={VOLUME_UNIT_TYPES_OPTIONs}
                  selectOption={(value: string | number) =>
                    setUnitTypes({ ...unitTypes, waterUnit: value })
                  }
                  transform={{
                    input: (value: any) => (isNaN(value) || value === 0 ? "" : value.toString()),
                    output: (e: any) => {
                      return e;
                    }
                  }}
                  control={control}
                  labelName={"Water (input)"}
                  placeholder="0"
                  name={`water`}
                  valueAsNumber={true}
                />
              </Grid.Column>
              <Grid.Column
                computer={4}
                tablet={8}
                mobile={16}
                className="paddingRemoveTop"
              ></Grid.Column>
              {addIngredientActive && (
                <Grid.Column computer={8} tablet={16} mobile={16}>
                  <label className={`inputTextLable`}>Associate ingredients</label>
                  <CustomButton
                    customColumnStyle="processingCustomColumnStyle"
                    customButtonStyle="customBtn"
                    theme="green"
                    title={`+ ${"  "}Add Ingredients`}
                    onClick={() => setViewIngredient(true)}
                  />
                </Grid.Column>
              )}
            </Grid>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </>
  );
};

export default SimulationMeasurementDetails;
